import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, UserWizardService, ValidationService } from 'lib/ng2-sapmp/src/providers';
import {
  GridOptionsModel, ColumnDefinitionsModel,
  PaginationsModel, FetchCriteriaModel
} from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { GridFetchModel } from './../../models/grid/grid-fetch.model';
import { UserListService } from './shared/providers/userList.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BREADCRUMBS } from 'config';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import {
  USER_PRODUCT_CLASS, USER_PRODUCT_FETCH, USER_PRODUCT_LICENSEDATA,
  USER_PRODUCT_PROVISIONSTATUS, USER_PRODUCT_SEARCH_CLASS
} from './manage-product.config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { ManageUserModel } from './manage-user.model';

import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;

declare var initAriaHidden: any;
declare var removeAriaHidden: any;

@Component({
  selector: 'app-manage-product',
  providers: [UserListService, ValidationService, AdobeAnalyticsService],
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss']
})
export class ManageProductComponent implements OnInit, OnDestroy {
  rowUser: ManageUserModel;
  modalClass: string;
  eventEmit: any;
  unAssignPopup: boolean;
  totalLicenses: any;
  licensesAssigned: any;
  leftLabel: any;
  rightLabel: any;
  singleUserDetail: any = null;
  licenseForm: FormGroup;
  breadCrumbs: BreadCrumbModel[];
  productId: string;
  fan: string;
  ctn: string;
  productDescription: string;
  singleBreadCrumb: BreadCrumbModel;
  gridOptions: GridOptionsModel;
  alterLicense: string;
  createUser: string;
  focusabbleElements: any;
  ufocusabbleElements: any;
  assignUnassign: string;
  changeProduct: string;
  editNameFlag: boolean;
  popUpFlag: boolean;
  assignProductFlag: boolean;
  userWizardModel: UserWizardModel;
  gridfetchModel: GridFetchModel = new GridFetchModel();
  reviewComponentSuccessMessageFlag = false;
  reviewComponentSuccessMessage: string = undefined;
  serviceUrl: string;
  serviceClientId: string;
  singleQuantityInfo: boolean;
  user: UserProfileModel;
  errorMessage: string;
  dataFlag: boolean;
  dataerrorMessage: string;
  unAssignModalPopUpFlag; boolean;
  csrPermissionUnassignPopButton: boolean;
  pivots: Array<MobilePivotModel>;
  modalCoverClass = 'scrollcontent';

  @ViewChild('unAssign', { static: true }) unassignElement;
  @ViewChild('assignGroup', { static: true }) assignGroupElement;
  columnDefinitions: Array<ColumnDefinitionsModel> = [
    { caption: 'User', field: 'firstName', type: 'LINK', sortDirection: 'Default',
    enableSorting: true, enableFilter: true, cssClass: 'contentStyle', priority: 1 },
    { caption: 'Email', field: 'email', type: 'TEXT', enableSorting: false, enableFilter: false, priority: 3 },
    { caption: 'Action', field: 'licenseStatus', type: 'LINK', enableSorting: false, enableFilter: false, priority: 2 }

  ];
  startIndex = 0;
  paginations: PaginationsModel = { // ag4104 need to change after demo
    recordsPerPage: 20,
    currentPage: 1,
    totalRecords: 0,
    isServerSide: true
  };

  formErrors = {
    'productName': ''
  };
  validationMessages = {
    'productName': {
      'required': 'Enter a license group name, or click Cancel.',
      'pattern': 'Enter a valid license group name, or click Cancel.'
    }
  };

  @ViewChild('assign') assignElement;

  constructor(private router: Router,
    private userListService: UserListService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private validationService: ValidationService,
    private http: HttpClient, private userWizardService: UserWizardService,
    private breadCrumbService: BreadCrumbService,
    private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    this.userWizardService.removeAssignOrUnassignWizard();
    this.csrPermissionUnassignPopButton = this.utilityService.checkFieldPermission('singleProduct.unAssign',
      JSON.parse(sessionStorage.getItem('permissions')).perm);

    if (sessionStorage.getItem('singleUserDetail') === null) {
      this.router.navigate(['/home']);
    } else {
        this.user = this.authenticationService.getUser();
        this.customColumnDefinitions();
        this.getProductDetails();
        this.unAssignModalPopUpFlag = false;
        this.popUpFlag = false;
        this.singleQuantityInfo = false;
        this.assignProductFlag = false;
        this.editNameFlag = false;
        const fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();
        fetchCriteria.limit = this.paginations.recordsPerPage;
        fetchCriteria.offset = this.startIndex;
        fetchCriteria.sortDir = 'ASC';
        fetchCriteria.sortField = 'id';
        const gridfetchModel: GridFetchModel = new GridFetchModel();
        this.gridfetchModel.licenseStatus = 'ASSIGNED';
        this.gridfetchModel.serviceClientId = this.serviceClientId;
        this.gridfetchModel.fetchCriteria = fetchCriteria;
        this.serviceUrl = this.utilityService.getEnvConfig().productLicenseUrl + this.user.companyId + '/licenses';
        this.getData(this.gridfetchModel, this.serviceUrl);
        this.alterLicense = 'manageProduct.increase';
        this.createUser = 'manageProduct.createuser';
        this.assignUnassign = 'manageProduct.assignunassign';
        this.changeProduct = 'manageProduct.changeproduct';
        this.userWizardModel = new UserWizardModel();
        this.singleBreadCrumb = new BreadCrumbModel();
        this.unAssignPopup = false;
        this.dataFlag = false;
        this.pivots = new Array<MobilePivotModel>();
    }

  }

  customColumnDefinitions() {
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));
    for (let i = 0; i < permissions.perm.length; i++) {
      if (permissions.perm[i].instance === 'manageProduct.action' && permissions.perm[i].action === 'hide') {
        this.columnDefinitions.splice(this.columnDefinitions.findIndex(x => x.field === 'licenseStatus'));
      }
    }
  }

  ngOnInit() {
    this.reviewComponentSuccessMessageFlag = false;
    this.reviewComponentSuccessMessage = null;
    this.unAssignModalPopUpFlag = false;
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.pivots.push({ label: 'Manage Products', routerLink: '/manage' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('singleUserDetail') !== null) {
      this.leftLabel = 'Licenses assigned:';
      this.rightLabel = '';
      const isSingleQuantity = JSON.parse(sessionStorage.getItem('singleUserDetail'));
      this.singleQuantityInfo = isSingleQuantity.isSingleQuantity;
      console.log(this.singleQuantityInfo);
      document.body.classList.add('manageproduct-page');
      // document.title = 'AT&T Business Console - Manage Product';
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.breadCrumbService.setCurrentBreadCrumb({ label: this.singleUserDetail.specName, routerLink: '/manageProduct' });
      this.buildForm();
      sessionStorage.removeItem('reviewModel');
      this.userListService.createPageLoadProperties([this.singleUserDetail.serviceOfferCode],
        this.router.routerState.snapshot.url,
        'Manage Product');
    }
  }

  modifyLicense(state) {
    const singleProductInfo = JSON.parse(sessionStorage.getItem('singleUserDetail'));
    singleProductInfo.modifyType = state;
    delete singleProductInfo['enteredQty'];
    sessionStorage.setItem('singleUserDetail', JSON.stringify(singleProductInfo));
    this.router.navigate(['manageProduct/modifyLicense']);
  }

  getProductDetails() {
    this.singleUserDetail = JSON.parse(sessionStorage.getItem('singleUserDetail'));
    this.productId = this.singleUserDetail;
    this.fan = this.singleUserDetail.brokerAccountClientId;
    this.ctn = this.singleUserDetail.billingClientId;
    this.totalLicenses = this.singleUserDetail.quantity;
    this.licensesAssigned = this.singleUserDetail.totalLicensesInUse;
    this.serviceClientId = this.singleUserDetail.clientId;
  }

  getData(gridfetchModel: GridFetchModel, url: string) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.userListService.userProductDetails
      (url, gridfetchModel).
      subscribe(respobj => {
        const options = new GridOptionsModel();
        const data = this.generateLicenseData(respobj);
        options.enableFiltering = true;
        options.enableSorting = true;
        options.gridData = data;
        options.columnDefinitions = this.columnDefinitions;
        options.enableSearchLimit = true;
        options.searchLimit = 3;
        options.enableBackLink = true;
        options.backLinkText = 'View all users';
        this.paginations.totalRecords = respobj.totalLength;
        if (!!!gridfetchModel.searchValue) {
          // Without filter,total records count assigned to licensesAssigned
          this.licensesAssigned = this.paginations.totalRecords;
        }
        options.Paginations = this.paginations;
        if (data.length <= 0) {
          options.showPaginationIndex = false;
          options.enableSorting = false;
          options.isEmptyMessageInRow = true;
          options.emptyMessage = 'No match found. Make sure to enter the exact name you\'re looking for and try again.';
        }
        this.gridOptions = options;
        this.reviewSuccess();
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
  }

  generateLicenseData(data) {
    const licenseData = new Array<ManageUserModel>();
    let obj: ManageUserModel;
    if (data && !!data.dataJson) {
      for (let i = 0; i < data.dataJson.length; i++) {
        obj = new ManageUserModel();
        // service
        if (!!data.dataJson[i].assignedToEmployeeClientId) {
          obj.firstName = data.dataJson[i].assignedToEmployeeFirstName + ' ' + data.dataJson[i].assignedToEmployeeLastName;
          obj.email = data.dataJson[i].assignedToEmployeeEmail;
          obj.id = data.dataJson[i].assignedToEmployeeClientId;
          obj.licenseClientId = data.dataJson[i].clientLicenseId;
          obj.licenseStatus = 'Un-assign';
        } else {
          obj.firstName = data.dataJson[i].firstName + ' ' + data.dataJson[i].lastName;
          obj.email = data.dataJson[i].email;
          obj.id = data.dataJson[i].clientId;
          obj.licenseStatus = 'Un-assign';
        }
        licenseData.push(obj);
      }
    }
    return licenseData;
  }

  linkActivated(data, focusable) {
    this.rowUser = data;
    if (!!data.selectedColumn && data.selectedColumn === 'firstName') {
      this.router.navigate(['user/summary/' + data.id]);
    }
    if (data.selectedColumn === 'licenseStatus') {
      this.unAssignPopup = true;
      this.modalClass = 'modal-lg';
      setTimeout(() => { document.getElementById('modalHeader').focus(); });
    }
    this.reviewComponentSuccessMessageFlag = false;
    return false;
  }


  handleError = (error, assignUnassignError?) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      this.reviewComponentSuccessMessageFlag = true;
      if (error.status === 401) {
        this.errorMessage = 'Session expired.Please login again.';
        logoutCurrentUser(true);
      } else if (assignUnassignError) {
        // tslint:disable-next-line:max-line-length
        this.errorMessage = 'We were unable to process your request to un-assign product licenses. If you need help, call 866.241.6568 (TTY: 866.241.6567) Monday - Friday, 7 a.m. - 9 p.m. ET. Or you can chat with an expert during weekday calling hours, and from 8 a.m. - 5 p.m. ET on Saturday and Sunday.';
      } else {
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  ngOnDestroy() {
  }

  private assignUnassignWizard() {
    this.userWizardModel.product = {};
    this.userWizardModel.source = 'product';
    this.userWizardModel.product.productName = this.singleUserDetail.specName;
    this.userWizardModel.product.fan = this.singleUserDetail.brokerAccountClientId;
    this.userWizardModel.product.ctn = this.singleUserDetail.billingClientId;
    this.userWizardModel.product.dcmCode = this.singleUserDetail.serviceOfferCode;
    this.userWizardModel.product.clientId = this.singleUserDetail.clientId;
    this.userWizardModel.product.licensegroupName = this.singleUserDetail.productDesc;
    this.userWizardModel.product.totalLicensesAvailable = this.totalLicenses - this.licensesAssigned;
    this.userWizardModel.product.totalLicensesInUse = this.licensesAssigned;
    this.userWizardModel.previousUrl = this.router.url;
    this.userWizardService.addAssignOrUnassignWizard(this.userWizardModel);
    this.router.navigate(['/manageUsers']);
  }





  updateUnAssignDetails(event) {
    this.reviewComponentSuccessMessageFlag = false;
    const reqObj = {};
    const items = {};
    items['action'] = 'UNASSIGN';
    items['employeeClientId'] = this.rowUser.id;
    items['serviceClientId'] = this.serviceClientId;
    items['licenseClientId'] = this.rowUser.licenseClientId;
    reqObj['items'] = [items];
    this.pageloaderService.setPageLoaderStatus(false);
    this.userListService.unAssignUser(this.utilityService.getEnvConfig().unAssignUrl, this.user.companyId, reqObj)
      .subscribe(response => {
        let respArray = [];
        respArray = response.items.filter(data => (!!data.statusInfo && data.statusInfo.status === 'COMPLETED'));
        if ((respArray.length === 0) && response.status !== 'COMPLETED') {
          this.pageloaderService.setPageLoaderStatus(true);
          this.unAssignModalPopUpFlag = false;
          this.reviewComponentSuccessMessage = null;
          this.handleError('error', true);
        } else {
          this.pageloaderService.setPageLoaderStatus(true);
          this.unAssignModalPopUpFlag = true;
          this.reviewComponentSuccessMessage = 'We\'ve successfully un-assigned 1 of 1 licenses.';
          this.utilityService.loadFocusOnTop();
          this.gridfetchModel.fetchCriteria.offset = 0;
          this.getData(this.gridfetchModel, this.serviceUrl);
        }
      }, error => {
        this.unAssignModalPopUpFlag = false;
        this.reviewComponentSuccessMessage = null;
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    this.unAssignPopup = false;
    document.body.classList.remove('modal-open');
    removeAriaHidden();
  }

  cancel(event) {
    this.unAssignModalPopUpFlag = false;
    this.focusabbleElements = undefined;
    this.unAssignPopup = false;
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.btnAction(event);
  }

  gridEventChanges(fetchCriteria: FetchCriteriaModel) {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.reviewComponentSuccessMessage = null;
    this.gridfetchModel = new GridFetchModel();
    if (!!fetchCriteria.sortField || !!fetchCriteria.searchValue) {
      if (!!fetchCriteria.searchValue) {
        this.gridfetchModel.searchValue = fetchCriteria.searchValue;
        delete fetchCriteria.searchValue;
      }
      this.gridfetchModel.withSubscriptions = [this.serviceClientId];
      this.serviceUrl = this.utilityService.getEnvConfig().productLicenseUrl
        + this.user.companyId + '/employees/textSearch';
    } else {
      this.gridfetchModel.licenseStatus = 'ASSIGNED';
      this.gridfetchModel.serviceClientId = this.serviceClientId;
      this.serviceUrl = this.utilityService.getEnvConfig().productLicenseUrl
        + this.user.companyId + '/licenses';
    }

    fetchCriteria.sortDir = (!!fetchCriteria.sortDir) ? fetchCriteria.sortDir : 'ASC';
    fetchCriteria.sortField = (!!fetchCriteria.sortField) ? fetchCriteria.sortField : 'id';
    this.gridfetchModel.fetchCriteria = fetchCriteria;
    this.getData(this.gridfetchModel, this.serviceUrl);
    this.utilityService.setSuccessMessage(null);
  }

  reviewSuccess() {
    if (((sessionStorage.getItem('previousRoute') === '/manageUsers/review') && (this.utilityService.getSuccessMessage() != null))
      || this.unAssignModalPopUpFlag) {
      this.reviewComponentSuccessMessageFlag = true;
      if (!this.reviewComponentSuccessMessage) {
        this.reviewComponentSuccessMessage = this.utilityService.getSuccessMessage();
        this.utilityService.loadFocusOnTop();
      }
    } else {
      this.reviewComponentSuccessMessageFlag = false;
    }
  }

  assignName() {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.reviewComponentSuccessMessage = null;
    this.popUpFlag = true;
    this.assignProductFlag = true;
    this.modalClass = 'modal-lg';
    setTimeout(() => { document.getElementById('modalHeader').focus(); });
    this.btnAction(event);
  }

  editName() {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.popUpFlag = true;
    this.editNameFlag = true;
    this.modalClass = 'modal-lg';
    setTimeout(() => { document.getElementById('modalHeader').focus(); });
    this.btnAction(event);
  }

  cancelButton(event) {
    this.popUpFlag = false;
    this.unAssignModalPopUpFlag = false;
    this.assignProductFlag = false;
    this.editNameFlag = false;
    this.licenseForm.reset();
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.btnAction(event);
  }

  assignButton(event) {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    this.reviewComponentSuccessMessage = null;
    this.unAssignModalPopUpFlag = false;
    this.reviewSuccess();
    this.singleUserDetail.productDesc = this.licenseForm.get('productName').value;
    this.cancelButton(event);
    this.btnAction(event);
    this.pageloaderService.setPageLoaderStatus(false);
    this.userListService.setUpdateProduct(this.utilityService.getEnvConfig().setUpdateUrl, this.singleUserDetail)
      .subscribe(response => {
        this.pageloaderService.setPageLoaderStatus(true);
        sessionStorage.setItem('singleUserDetail', JSON.stringify(this.singleUserDetail));
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
  }

  buildForm() {
    this.licenseForm = this.formBuilder.group({
      productName: ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]]
    });

    this.validationService.validate(
      this.licenseForm,
      this.formErrors,
      this.validationMessages);
  }

  btnAction(event) {
    this.focusabbleElements = undefined;
    this.ufocusabbleElements = undefined;
    if (event.target) {
      event.target.focus();
    }
  }

  loadFocustelements() {
    if (this.popUpFlag || this.unAssignPopup) {
      document.body.classList.add('modal-open');
      initAriaHidden();
      if (!this.focusabbleElements) {
        const focusableEls = this.unassignElement.nativeElement.
          querySelectorAll('a[href], area[href],' +
            ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.focusabbleElements = Array.prototype.slice.call(focusableEls);
        document.getElementById('modalHeader');
      }
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(event);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  UloadFocustelements() {
    if (this.popUpFlag) {
      document.body.classList.add('modal-open');
      initAriaHidden();
      if (!this.ufocusabbleElements) {
        const focusableEls = this.assignGroupElement.nativeElement.
          querySelectorAll('a[href], area[href],' +
            ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.ufocusabbleElements = Array.prototype.slice.call(focusableEls);
        document.getElementById('modalHeader');
      }
    }
  }

  UhandleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(event);
      return;
    }
    this.utilityService.handleKeyPress(event, this.ufocusabbleElements);
  }

}

